import { useMemo } from 'react'
import { useSelector } from 'react-redux'

import { selectWorkingDayStartSec } from '@/features/domain/territory'
import { selectTrafficTimeWindows } from '@/features/domain/traffic'
import { timeWindowUtils } from '@/utils'

export function useFormInitialValues() {
  const timeWindows = useSelector(selectTrafficTimeWindows)
  const workingDayStartSec = useSelector(selectWorkingDayStartSec)

  return useMemo(() => {
    const formattedTimeWindows = timeWindows.reduce<uui.domain.rm.TimeWindow[]>((acc, tw) => {
      if (!tw) return acc

      acc.push(timeWindowUtils.formatTimeWindow(tw, workingDayStartSec))

      return acc
    }, [])

    return {
      timeWindows: formattedTimeWindows,
    }
  }, [timeWindows, workingDayStartSec])
}
